import React, { useState, useEffect } from 'react';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import Modal from 'new/components/Modal';
import Button from 'new/components/Button/Button';
import { TENANT } from 'new/tenants';

type Props = {
  open: boolean;
  onConfirm: () => void;
  onClose: () => void;
  isLoading: boolean;
};

const ConfirmationModal = styled(Modal)(({ theme }) => ({
  fontFamily: TENANT.theme.modal.fontFamily,

  '.title': {
    fontFamily: TENANT.theme.modal.fontFamily,
    fontWeight: 'bold',
    textAlign: 'center',
    fontSize: '1.75rem',
    color: theme.palette.primary.dark,
    marginBottom: theme.spacing(3),
  },

  '.confirmationContent': {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    width: 480,
    textAlign: 'center',
    color: theme.palette.grey[600],
    margin: `${theme.spacing(4)} 0`,
  },

  '.buttonFooter': {
    display: 'flex',
    justifyContent: 'center',
    gap: theme.spacing(2),
  },
}));

const ConfirmCoordinatorModal: React.FC<Props> = ({
  open,
  onConfirm,
  onClose,
  isLoading,
}) => {
  const [isSecondModal, setIsSecondModal] = useState(false);

  useEffect(() => {
    if (!open) {
      setIsSecondModal(false);
    }
  }, [open]);

  const handleNext = () => {
    if (isSecondModal || !TENANT.features.changePlanCoordinatorDoubleConfirm) {
      onConfirm();
    } else {
      setIsSecondModal(true);
    }
  };

  const handleBack = () => {
    if (isSecondModal && TENANT.features.changePlanCoordinatorDoubleConfirm) {
      setIsSecondModal(false);
    } else {
      onClose();
    }
  };

  return (
    <ConfirmationModal
      open={open}
      onClose={onClose}
      title={
        isSecondModal ? (
          <>
            Are you <i>absolutely certain?</i>
          </>
        ) : (
          'Assign Plan Coordinator?'
        )
      }
    >
      {isSecondModal ? (
        <Box className="confirmationContent" fontWeight="bold" pb={2}>
          You cannot undo this action.
        </Box>
      ) : (
        <Box className="confirmationContent">
          <Box>
            The Plan Coordinator is considered the point person to manage your
            membership plans. This is often assigned to the Office (or Regional)
            Manager of a specific location.
          </Box>
          <Box fontWeight="bold">
            There can only be one person assigned as the Plan Coordinator.{' '}
          </Box>
          <Box>
            Only the Plan Coordinator (and Business Owner) can assign a new Plan
            Coordinator. Click on the shield icon at any time to adjust a user's
            permission level.
          </Box>
        </Box>
      )}

      <Box className="buttonFooter">
        <Button variant="outlined" color="secondary" onClick={handleBack}>
          CANCEL
        </Button>
        <Button onClick={handleNext} isLoading={isLoading}>
          YES, CHANGE
        </Button>
      </Box>
    </ConfirmationModal>
  );
};

export default ConfirmCoordinatorModal;
